import { Component, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { PeakEventFormComponent } from '@app/components/forms/peak-event/form.component';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { PeakEvent, PeakEventCreate } from '@app/models/peak-event.interface';
import { PeakEventHelperService } from '@app/services/helpers/peak-event-helper.service';
import { ToastService } from '@app/services/toast.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-peak-event-edit',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        PeakEventFormComponent,
        FontAwesomeModule,
        RouterModule,
    ],
    templateUrl: './edit.page.html',
    styleUrl: './edit.page.scss'
})
export class PeakEventEditPage {
  public title = 'Peak Event Edit';
  formValid = signal(false);
  formValue = signal<PeakEventCreate | null>(null);
  id: number;
  peakEvent$: Observable<PeakEvent>;

  faSave = faSave;
  faArrowLeft = faArrowLeft;

  constructor(
    private route: ActivatedRoute,
    private peakEventHelper: PeakEventHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    this.id = this.route.snapshot.params['id'];
    this.peakEvent$ = this.peakEventHelper.getById(this.id);
  }

  update() {
    let val = this.formValue();
    if(val)
      this.peakEventHelper.update(this.id, val).subscribe({
        next: (success) => { this.router.navigate(['peak-events', this.id]); },
        error: (err: AppHttpError) => {
          this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
        }
      });
  }
}
